import {
  CdkDrag,
  CdkDragDrop,
  CdkDragPlaceholder,
  CdkDropList,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AppState } from "../../../app.state";
import { select, Store } from "@ngrx/store";
import { selectDespachoEntradas } from "../../../states/despacho/selector";
import { IEntrada, INuevaEntrada } from "../../../interfaces/entradas";
import { MatGridListModule } from "@angular/material/grid-list";
import { Router, RouterLink } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { CancelarEntregableComponent } from "../dialogs/cancelar-entregable/cancelar-entregable.component";
import { TerminarEntregableComponent } from "../dialogs/terminar-entregable/terminar-entregable.component";
import { TerminarTemaComponent } from "../dialogs/terminar-tema/terminar-tema.component";
import { TerminarSeguimientoComponent } from "../dialogs/terminar-seguimiento/terminar-seguimiento.component";
import { QuitarTemaComponent } from "../dialogs/quitar-tema/quitar-tema.component";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import { StorageService } from "../../../services/storage/files.service";
import { IArchivoAdjunto } from "../../../interfaces/storage";
import { LoadingService } from "../../../loading/loading.service";
import { DespachoService } from "../../../services/despacho/despacho.service";
import { selectUsuario } from "../../../states/usuario/selector";
import { MatBadgeModule } from "@angular/material/badge";
import { EntradasService } from "../../../services/entradas/entradas.service";
import { firstValueFrom } from "rxjs";
import { EntregablesService } from "../../../services/entregables/entregables.service";

@Component({
  selector: "app-form-temas",
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    FormsModule,
    MatCardModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    //AsyncPipe,
    CdkDropList,
    CdkDrag,
    CdkDragPlaceholder,
    MatTooltipModule,
    MatGridListModule,
    MatCheckboxModule,
    RouterLink,
    MatBadgeModule,
  ],
  templateUrl: "./form-temas.component.html",
  styleUrl: "./form-temas.component.css",
})
export class FormTemasComponent {
  @Input() temasForm!: any;
  @Input() formName!: string;
  private readonly store: Store<AppState> = inject(Store);
  private stateUser: any = this.store.pipe(select(selectUsuario));

  private stateEntradas: any = this.store.pipe(select(selectDespachoEntradas));
  public listaEntradas: any[] = [];
  public accioonSeleccionada = null;
  private loadingService = inject(LoadingService);
  public filteredEntradas: any = [];
  public entradasEncontradas = -1;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private acuerdosService: AcuerdosService,
    private storageService: StorageService,
    public despachoService: DespachoService,
    private entradasService: EntradasService,
    private entregablesService: EntregablesService
  ) {}
  async ngOnInit() {
    console.log(" this.temasForm.", this.temasForm);

    const user = structuredClone(this.stateUser.state().usuario.temas);
    const id_empresa = structuredClone(
      this.stateUser.state().formaEnvio.despacho.id_empresa
    );
    const temas = Object.keys(user).map((key) => ({
      id_categorizacion: key,
      id_tipo_forma: 2,
      id_empresa,
    }));

    const consultar = await firstValueFrom(
      this.entradasService.obtenerEntradas(temas)
    );
    console.log("consultar", consultar);
    this.listaEntradas = consultar.error ? [] : consultar.entradas;

    if (this.formName) {
      this.disabledEntrada(this.formName);
    }
  }

  getLista(entradas: IEntrada[]): IEntrada[] {
    const uniqueEntries = entradas.reduce(
      (acc: IEntrada[], entrada: IEntrada) => {
        if (!acc.some((e) => e.id_entrada === entrada.id_entrada)) {
          acc.push(entrada);
        }
        return acc;
      },
      [] 
    );
    return uniqueEntries;
  }

  async disabledEntrada(formName: string, entrada?: any) {
    const entradasActuales = this.obtenerFormArray(
      this.formName
    )?.value.flatMap((form: any) => form.entradas);
    console.log("entradasActuales", entradasActuales);

    console.log("last idEntrada", entrada);
    const entradaEliminada = entrada ? [entrada] : [];

    const updateEliminado = entrada
      ? entradasActuales.filter(
          (ent: any) => ent.id_entrada != entrada.id_entrada
        )
      : entradasActuales;
    const initialState = entrada
      ? [...this.listaEntradas, entrada]
      : this.listaEntradas;
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      updateEliminado,
      initialState
    );
    console.log("entradasFiltradas", entradasFiltradas);

    this.listaEntradas = entradasFiltradas;
    const formArray = this.obtenerFormArray(formName)?.controls;
    const action = entradasFiltradas.length <= 0 ? "disable" : "enable";
    formArray?.forEach((f) => {
      const form = f as FormGroup;
      form.get("entradaSelected")?.[action]();
    });
  }

  public acciones = [
    { value: 4, label: "Mover" },
    { value: 7, label: "Quitar" },
    { value: 6, label: "Cancelar entregable" },
    { value: 2, label: "Terminar entregable" },
    { value: 5, label: "Terminar seguimiento" },
    { value: 3, label: "Terminar" },
  ];

  isFormGroup(control: any): control is FormGroup {
    return control instanceof FormGroup;
  }

  // get informativoFormArray(): FormArray {
  //   return this.temasForm.get("informativo") as FormArray;
  // }

  // get voboFormArray(): FormArray {
  //   return this.temasForm.get("vobo") as FormArray;
  // }

  esFormArray(control: AbstractControl | null): control is FormArray {
    return control instanceof FormArray;
  }

  obtenerFormArray(nombre: string): FormArray | null {
    const control = this.temasForm.get(nombre);
    return this.esFormArray(control) ? control : null;
  }

  // obtenerFormArray(formName: FormGroup): FormArray {
  //   return this.temasForm.get(formName) as FormArray;
  // }

  async updateAutocomplete(event: any, temaForm: any) {
    const value = temaForm.get("entradaSelected").value ?? "";
    const state = await this.stateEntradas.state().formaEnvio.entradas;

    const entradasActuales = this.obtenerFormArray(
      this.formName
    )?.value.flatMap((form: any) => form.entradas);

    const initialState = state;
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );

    if (!value) {
      this.listaEntradas = entradasFiltradas;
    }
    if (value) {
      this.listaEntradas = entradasFiltradas.filter((entrada: IEntrada) => {
        return (
          entrada.nombreEntradaCompleto &&
          entrada.nombreEntradaCompleto
            .toLowerCase()
            .includes(value.toLowerCase())
        );
      });
    }
  }

  onItemSelected(event: MatAutocompleteSelectedEvent, temaForm: any): void {
    const option = event.option.value;
    console.log("option", option);
    this.loadingService.show();

    const entradaSelected = temaForm.get("entradaSelected") as FormControl;
    console.log("entradaSelected", entradaSelected);

    const temaId = temaForm.get("idTema");
    const nuevoEntrada: INuevaEntrada = {
      id_entrada: option.id_entrada,
      idEntrada: option.id_entrada,
      idCategorizacion: option.id_categorizacion,
      idTema: temaId?.value,
      indiceEntrada: entradaSelected?.value.length,
      nombreEntrada: option.nombreEntrada,
      tieneSeguimiento: 0,
      esActivo: option.banEsActivo,
      remitente_descripcion: option.remitente_descripcion,
      fecha_inicio: "",
      documentoSoporte: option.documentoSoporte,
      esDocumentoSoporte: false,
      archivos: [],
      nombreEntradaCompleto: option.nombreEntradaCompleto,
      entregables: [],
      nuevo: true,
      nombre_empresa:option.desc_empresa ?? ""
    };
    this.listaEntradas = this.listaEntradas.filter(
      (ent) => ent.id_entrada !== option.id_entrada
    );

    this.acuerdosService
      .getEntregableArchivos(option.id_entrada)
      .then((data) => {
        data.subscribe((files) => {
          const entradasControl = temaForm.get("entradas");

          const updatedEntrada = {
            ...nuevoEntrada,
            archivos: [...files.archivos],
            entregables: [...files.entregables],
          };

          const nuevasEntradas = [...entradasControl.value, updatedEntrada];

          entradasControl.setValue(nuevasEntradas);
          entradaSelected.setValue("");

          this.disabledEntrada(this.formName);
          this.loadingService.hide();
        });
      });
  }
  async onFocus(event: any, temaForm: any) {
    await this.disabledEntrada(this.formName);
  }

  async onBlur(event: any, temaForm: any) {
    const entradaSelected = temaForm.get("entradaSelected");
    entradaSelected.setValue("");
  }
  async onChangeEvent() {
    await this.disabledEntrada(this.formName);
  }

  async onInput(event: any, temaForm: any, index: any) {
    const state = await this.stateEntradas.state().formaEnvio.entradas;

    const entradasActuales = this.obtenerFormArray(
      this.formName
    )?.value.flatMap((form: any) => form.entradas);

    const initialState = state;
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );

    const value = event.target.value ?? "";
    const nombreEntrada = value.trim() === "" ? "" : value.trim();

    if (!nombreEntrada) {
      this.entradasEncontradas = index;
      this.listaEntradas = entradasFiltradas;
    }
    if (nombreEntrada) {
      this.entradasEncontradas = -1;
      this.listaEntradas = entradasFiltradas.filter((entrada: IEntrada) => {
        return (
          entrada.nombreEntradaCompleto &&
          entrada.nombreEntradaCompleto
            .toLowerCase()
            .includes(nombreEntrada.toLowerCase())
        );
      });
    }
  }

  filtrarEntradasActuales(
    entradaControl: IEntrada[],
    orignalState: IEntrada[]
  ) {
    const data = orignalState.filter((entrada: IEntrada) => {
      return !entradaControl.some(
        (controlEntrada: IEntrada) =>
          controlEntrada.id_entrada === entrada.id_entrada
      );
    });
    console.log("data", data);
    return data;
  }
  selectEntrada(option: any, temaForm: any) {
    this.loadingService.show();

    const entradaSelected = temaForm.get("entradaSelected") as FormControl;

    const temaId = temaForm.get("idTema");
    const nuevoEntrada: INuevaEntrada = {
      id_entrada: option.id_entrada,
      idEntrada: option.id_entrada,
      idCategorizacion: option.id_categorizacion,
      idTema: temaId?.value,
      indiceEntrada: entradaSelected?.value.length,
      nombreEntrada: option.nombreEntrada,
      tieneSeguimiento: 0,
      esActivo: option.banEsActivo,
      remitente_descripcion: option.remitente_descripcion,
      fecha_inicio: "",
      documentoSoporte: option.documentoSoporte,
      esDocumentoSoporte: false,
      archivos: [],
      nombreEntradaCompleto: option.nombreEntradaCompleto,
      entregables: [],
      nuevo: true,
    };
    this.listaEntradas = this.listaEntradas.filter(
      (ent) => ent.id_entrada !== option.id_entrada
    );

    this.acuerdosService
      .getEntregableArchivos(option.id_entrada)
      .then((data) => {
        data.subscribe((files) => {
          const entradasControl = temaForm.get("entradas");

          const updatedEntrada = {
            ...nuevoEntrada,
            archivos: [...files.archivos],
            entregables: [...files.entregables],
          };

          const nuevasEntradas = [...entradasControl.value, updatedEntrada];

          entradasControl.setValue(nuevasEntradas);
          entradaSelected.setValue("");
          this.disabledEntrada(this.formName);
          this.loadingService.hide();
        });
      });
  }
  async eliminarEntrada(entrada: any, form: any) {
    const temaForm = form.get("entradas");
    const id_empresa = form.get("id_empresa").value;
    if (temaForm.value.length <= 1) {
      this.dialog.open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Importante",
          message:
            "El tema debe contener al menos una entrada. Seleccione la acción 'Quitar tema', si desea desasociar la entrada y eliminar el tema del despacho.",
          showButtons: {
            accept: true,
            cancel: false,
          },
          direction: "end",
          buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
        },
      });
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "¿Está seguro de eliminar la entrada del tema?",
        message: "Esta acción no se podrá deshacer.",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "BORRAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(async () => {
      this.listaEntradas = [...this.listaEntradas, entrada];
      try {
        this.listaEntradas = [...this.listaEntradas, entrada];
        await firstValueFrom(
          this.entradasService.elimminarEntrada(entrada.id_entrada)
        );

        const entradasControl = temaForm.value.filter((ent: any) => {
          const idEnt = ent.id_entrada ?? ent.id_entrada;
          const idEntrada = entrada.id_entrada ?? entrada.id_entrada;
          return idEntrada !== idEnt;
        });

        const user = structuredClone(this.stateUser.state().usuario.temas);
        const temas = Object.keys(user).map((key) => ({
          id_categorizacion: key,
          id_tipo_forma: 2,
          id_empresa,
        }));

        const nuevasEntradas = [...entradasControl];
        temaForm.setValue(nuevasEntradas);

        const consultar = await firstValueFrom(
          this.entradasService.obtenerEntradas(temas)
        );
        console.log("consultar", consultar);
        this.listaEntradas = consultar.error ? [] : consultar.entradas;

        const event = await this.disabledEntrada(this.formName, entrada);
      } catch (error) {}
    });
  }
  descargarEntregable(entrada: any, entregable: any) {
    this.loadingService.show();
    const id_entrada = entrada.idEntrada ?? entrada.id_entrada;
    const id_entregable = entregable.idEntregable ?? entregable.id_entregable;

    this.entregablesService
      .descargarEntregable({
        entrada: id_entrada,
        entregable: id_entregable,
      })
      .subscribe((result) => {
        if (result.error || result.data.error) {
          this.loadingService.hide();
          this.openModalError("Alerta", result.data.message.mensaje);
        } else {
          const ifrm = document.createElement("iframe");
          ifrm.setAttribute("src", result.data[0]);
          ifrm.style.width = "0px";
          ifrm.style.height = "0px";
          ifrm.style.border = "0";
          document.body.appendChild(ifrm);
          setTimeout(() => {
            document.body.removeChild(ifrm);
          }, 1000);
          this.loadingService.hide();
        }
      });
  }
  verArchivo(archivo: any) {
    this.storageService
      .obtenerArchivoUrl(archivo.id_entrada, archivo.nombre_archivo)
      .subscribe((data) => {
        console.log("data", data);
        if (!data.error) {
          window.open(data.url, "_blank");
        }
      });
  }
  eliminarArchivo(_archivo: any, entradas: any, id_entrada: string) {
    this.loadingService.show();
    const entradasForms = entradas as FormControl;

    this.storageService
      .obtenerArchivoUrl(_archivo.id_entrada, _archivo.nombre_archivo)
      .subscribe((data) => {
        console.log("data", data);
        const archivo: IArchivoAdjunto = {
          id_entrada: _archivo.id_entrada,
          indice: _archivo.indice,
          nombre_archivo: _archivo.nombre_archivo,
          metadata: _archivo.metadata,
          banEsActivo: _archivo.banEsActivo,
          ts_alta_audit: _archivo.ts_alta_audit,
          ts_actualiza_audit: _archivo.ts_actualiza_audit,
          usuario_audit: _archivo.usuario_audit,
          indiceEnTema: _archivo.indiceEnTema,
          urlDownload: data.url,
        };

        console.log("_archivo", _archivo);
        console.log("entradasForms", entradasForms);
        console.log("id_entrada", id_entrada);
        const updateFiles = entradasForms.value.map((entrada: any) => {
          if (entrada.id_entrada === id_entrada) {
            const new_archivos = entrada.archivos.filter((archivo: any) => {
              console.log("Checking archivo:", archivo.nombre_archivo);
              console.log("Checking archivo:", archivo.nombre_archivo);
              return archivo.nombre_archivo !== _archivo.nombre_archivo;
            });
            return { ...entrada, archivos: new_archivos };
          }
          return entrada;
        });

        this.storageService
          .eliminarArchivoAdjunto(_archivo)
          .subscribe((data) => {
            console.log("_archivo", _archivo);
            console.log("entradasForms", entradasForms);
            console.log("id_entrada", id_entrada);
            if (!data.error) {
              // Log the updated entries
              console.log("Updated Entries:", updateFiles);
              entradasForms.setValue(updateFiles);
            }
            this.loadingService.hide();
          });
      });
  }

  updateImpresion(item: any) {
    if (item.marcarParaImpresion) {
      this.despachoService.addImpresion(item.id_tema);
    } else {
      this.despachoService.removeImpresion(item.id_tema);
    }

    console.log(this.despachoService.getImpresion());
  }

  getImpresion(idTema: string, temaForm: any) {
    let encontrado = this.despachoService.getImpresion().includes(idTema);
    temaForm
      .get("marcarParaImpresion")
      ?.setValue(encontrado, { emitEvent: false });
  }

  getImpresionValue(idTema: string) {
    return this.despachoService.getImpresion().includes(idTema);
  }

  async getAccion(accion: any, temaForm: any) {
    const detalle = temaForm.value;
    let listaEntregables: any = [];
    for (let index in detalle.entradas) {
      let item = detalle.entradas[index].entregables;

      if (item.length > 0) {
        listaEntregables = listaEntregables.concat(item);
      }
    }

    console.log("listaEntregables", listaEntregables);
    console.log("getAccion", accion.value);
    console.log("detalle", detalle);

    let validacionExitosa = true;
    switch (accion.value) {
      case 2:
        const entregablesEnviados = listaEntregables.filter(
          (item: any) => item.id_edo_entregable < 5
        );
        console.log("entregablesEnviados", entregablesEnviados.length);

        if (entregablesEnviados.length === 0) {
          // detalle.id_edo_tema = null;
          this.openModalError(
            "Alerta",
            "No existen entregables en estado ‘Enviado a ejecución’."
          );
          validacionExitosa = false;
        }
        break;
      case 3:
        if (
          listaEntregables.filter((item: any) => item.id_edo_entregable < 5)
            .length > 0
        ) {
          // detalle.id_edo_tema = null;
          this.openModalError(
            "Alerta",
            "No es posible terminar el tema ya que cuenta con entregables activos."
          );
          validacionExitosa = false;
        }
        break;
      case 5:
        if (
          detalle.entradas.filter((item: any) => item.banConSeguimiento === 1)
            .length === 0
        ) {
          // detalle.id_edo_tema = null;
          this.openModalError(
            "Alerta",
            "No existen seguimientos para terminar."
          );
          validacionExitosa = false;
        }
        break;
      case 6:
        if (
          listaEntregables.filter((item: any) => item.id_edo_entregable < 5)
            .length === 0
        ) {
          // detalle.id_edo_tema = null;
          this.openModalError(
            "Alerta",
            "No existen entregables activos para cancelar."
          );
          validacionExitosa = false;
        }
        break;
    }
    if (validacionExitosa) {
      switch (accion.value) {
        case 6:
          const dialogRef = this.dialog.open(CancelarEntregableComponent, {
            minWidth: "550px",
            data: detalle,
          });

          break;
        case 2:
          this.loadingService.show();

          const enviadosEjecucion = await firstValueFrom(
            this.despachoService.listarEntregablesEnviadosAEjecucion(
              detalle.id_tema
            )
          );

          this.loadingService.hide();
          console.log("data", enviadosEjecucion);
          if (enviadosEjecucion.error && enviadosEjecucion.message.error) {
            this.openModalError("Error", enviadosEjecucion.message.msg);
          } else {
            this.dialog.open(TerminarEntregableComponent, {
              minWidth: "600px",
              data: detalle,
            });
          }

          break;
        case 3:
          this.dialog.open(TerminarTemaComponent, {
            minWidth: "600px",
            data: detalle,
          });
          break;
        case 4:
          this.router.navigate([`/mover/despacho/${detalle.id_tema}`]);
          break;
        case 5:
          this.dialog.open(TerminarSeguimientoComponent, {
            minWidth: "600px",
            data: detalle,
          });
          break;
        case 7:
          this.dialog.open(QuitarTemaComponent, {
            minWidth: "600px",
            data: detalle,
          });
          break;
        default:
          break;
      }
    }

    temaForm.get("accion").setValue(null);
  }

  openModalError(title: string, message: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "550px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {});

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }
  getLink(idCategorizacion: number, idEntrada: number): string {
    return `/#/entrada/${idCategorizacion}/${idEntrada}`;
  }

  //permisos para edicion/lectura/confidencial...
  getPermisoLectura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.lectura.includes(categorizacionTema);
  };

  getPermisoEscritura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.escritura.includes(categorizacionTema);
  };
  showEntrada = (entrada: any): boolean => {
    const soloLecura = this.getPermisoLectura(entrada.id_categorizacion);
    const soloEscritura = this.getPermisoEscritura(entrada.id_categorizacion);
    return soloLecura || soloEscritura || (soloLecura && soloEscritura);
  };

  dragDropTema(event: CdkDragDrop<any>, control: any) {
    console.log("temasFormArray", control.getRawValue());
    console.log("event", event);

    const nuevosTemas = [...control.getRawValue()]; // Clonar array
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;
    // Mover el ítem dentro del array
    moveItemInArray(nuevosTemas, previousIndex, currentIndex);
    const orderedTemas = nuevosTemas.map((tema: any, index: number) => ({
      ...tema,
      indice: index,
    }));
    control.setValue(orderedTemas);
    console.log("Updated temas:", orderedTemas);
  }
  dropEntrada(
    event: CdkDragDrop<string[]>,
    entradas: any,
    idTema: string,
    form: any
  ) {
    const nuevasEntradas = [...entradas];
    moveItemInArray(nuevasEntradas, event.previousIndex, event.currentIndex);
    console.log("nuevasEntradas", nuevasEntradas);

    const orderedEntradas = nuevasEntradas.map((ent, index) => ({
      ...ent,
      indiceEntrada: index,
      indice: index,
    }));

    form.setValue(orderedEntradas);
  }

  dropDragFiles(
    event: CdkDragDrop<string[]>,
    archivos: any,
    idTema: string,
    id_entrada: string,
    form: any
  ) {
    console.log("archivos", archivos);
    console.log("form", form);

    const entradaForm = form.value;
    const nuevosArchivos = [...archivos];
    moveItemInArray(nuevosArchivos, event.previousIndex, event.currentIndex);
    const orderedFiles = nuevosArchivos.map((ent, index) => ({
      ...ent,
      indice: index,
    }));
    const updatedEntradas = entradaForm.map((entrada: any) => {
      if (entrada.id_entrada === id_entrada) {
        return { ...entrada, archivos: orderedFiles };
      } else {
        return entrada;
      }
    });
    form.setValue(updatedEntradas);
  }
  dropDragEntregables(
    event: CdkDragDrop<string[]>,
    entregables: any,
    idTema: string,
    id_entrada: string,
    form: any
  ) {
    console.log("entregables", entregables);
    console.log("form", form);
    console.log("idEntrada", id_entrada);

    const entradaForm = form.value;
    console.log("entradaForm", entradaForm);

    const nuevosEntregables = [...entregables];
    console.log("nuevosEntregables antes", nuevosEntregables);
    moveItemInArray(nuevosEntregables, event.previousIndex, event.currentIndex);
    console.log("nuevosEntregables despuues", nuevosEntregables);

    const orderedEntregables = nuevosEntregables.map((ent, index) => ({
      ...ent,
      indice: index,
    }));
    console.log("orderedEntregables", orderedEntregables);

    const updatedEntradas = entradaForm.map((entrada: any) => {
      if (entrada.id_entrada === id_entrada) {
        return { ...entrada, entregables: orderedEntregables };
      } else {
        return entrada;
      }
    });
    console.log("updatedEntradas", updatedEntradas);

    form.setValue(updatedEntradas);
  }
}
